import { render, staticRenderFns } from "./ApplicantAddress.vue?vue&type=template&id=4781a70d&scoped=true&"
import script from "./ApplicantAddress.vue?vue&type=script&lang=js&"
export * from "./ApplicantAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781a70d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4781a70d')) {
      api.createRecord('4781a70d', component.options)
    } else {
      api.reload('4781a70d', component.options)
    }
    module.hot.accept("./ApplicantAddress.vue?vue&type=template&id=4781a70d&scoped=true&", function () {
      api.rerender('4781a70d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Apply/ApplicantAddress.vue"
export default component.exports